//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const OpenSearchRanking: FeatureFlag = {"Id":"OpenSearchRanking","Label":"[10.17]OpenSearchRanking","Impact":"Enable optional scoring for ranked value mapper queries in OpenSearch datasources.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
